<script lang="ts" setup>
import BatchUpdates from "@/data-views/tables/pricelist/BatchUpdates.vue";
import { loader } from "@/components/loader/loader";

definePage({
  meta: {
    action: "read",
    subject: "PriceConfiguration",
    navActiveLink: "pricelist-batch-updates",
  },
});

const loading = ref(false);

onMounted(() => {
  loading.value = true;
  setTimeout(() => {
    loading.value = false;
    loader.stop();
  }, 500);
});
</script>

<template>
  <VRow class="match-height">
    <VCol cols="12">
      <BatchUpdates v-if="!loading" />
      <div v-else style="min-height: 50vh" />
    </VCol>
  </VRow>
</template>
